import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { DisplayableImageContentTypes } from '../../constants-and-enums/image-types';
import { getHeroFileIcon } from 'src/app/shared/utils';

@Component({
    standalone: false,
    selector: 'app-file-uploader',
    templateUrl: './file-uploader.component.html',
    styleUrls: ['./file-uploader.component.scss']
})
export class FileUploaderComponent {
    @ViewChild('fileDropRef', { static: false }) fileDropEl: ElementRef;
    @Input() multiple = true;

    @Output() uploaded = new EventEmitter<any>();

    files: File[] = [];

    filePreviews = new Map<string, any>();

    getDocumentExtension(document: File): string {
        return document?.name.split('.').slice(-1).join('');
    }

    previewAvailable(file: File): boolean {
        return DisplayableImageContentTypes.includes((file as Blob).type);
    }

    onFilesSelected(files: FileList): void {
        if (!this.multiple) {
            this.filePreviews.clear();
            this.files.splice(0);
        }

        const length = this.multiple ? files.length : 1;

        for (let i = 0; i < length; i++) {
            const file = files.item(i);
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                this.filePreviews.set(file.name, reader.result);
            };

            this.files.push(file);
        }

        this.uploaded.emit(files);
    }

    onSelectClick(): void {
        this.fileDropEl.nativeElement.click();
    }

    removeFile(index: number, file: File): void {
        this.files.splice(index, 1);
        this.filePreviews.delete(file.name);
    }

    protected readonly getHeroFileIcon = getHeroFileIcon;
}

export class FileUploadModel {
    data: File;
    state: string;
    inProgress: boolean;
    progress: number;
    canRetry: boolean;
    canCancel: boolean;
    sub?: Subscription;
}
